module.exports = __webpack_public_path__ + "img/Frame 427320051.7e8b92a2.png";